import { RoutingHistoryService } from './../services/routingHistory.service';
import { Component, OnDestroy } from "@angular/core";
import { FormBuilder, FormGroup, FormArray } from "@angular/forms";
import { Router, ActivatedRoute } from '@angular/router';
import { UserService, StreamService } from '../services';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject, forkJoin } from 'rxjs';
import { takeUntil, flatMap, first, tap } from 'rxjs/operators';
import * as _ from 'lodash';

@Component({
    template: `
        <mat-card>
            <mat-card-content>
                <invitation-manager [form]="newUserForm" title="Invite New Members"></invitation-manager>
                <mat-card>
                    <mat-card-content>
                        <current-user-invitation-manager [form]="currentUserForm" [currentSubscribers]="currentSubscribers" style="display: block; padding-top: 15px;"></current-user-invitation-manager>
                    </mat-card-content>
                </mat-card>
            </mat-card-content>
            <mat-card-actions>
                <button mat-raised-button color="primary" [disabled]="isInvalid()" (click)="sendInvites()">Send Invitations</button>                
                <button mat-button (click)="cancel()">Cancel</button>
            </mat-card-actions>
        </mat-card>
    `
})
export class InviteToTopicComponent implements OnDestroy {
    private cleanupTime = new Subject<void>();
    newUserForm: FormGroup;
    currentUserForm: FormGroup;
    topic: any;
    currentSubscribers: any[];

    constructor(route: ActivatedRoute,
                fb: FormBuilder,
                private router: Router, 
                private snackBar: MatSnackBar,
                private routingHistoryService: RoutingHistoryService,
                streamService: StreamService,
                private userService: UserService) {
        this.newUserForm = fb.group({});
        this.currentUserForm = fb.group({});
        route.parent.params
        .pipe(
            takeUntil(this.cleanupTime),
            tap(params => { streamService.getStreamFollowers(params.topicId, { rows: 500}).pipe(first()).subscribe(followers => this.currentSubscribers = followers.content); }),
            flatMap(params => streamService.getStream(params.topicId))
        )
        .subscribe(stream => this.topic = stream);
    }

    cancel(): void {
        this.router.navigateByUrl(this.routingHistoryService.getPreviousUrl());
    }

    allNonEmptyNewInvitesValid(): boolean {
        return this.nonEmptyNewInvites().reduce((accum, control) => control.valid && accum, true);
    }

    nonEmptyNewInvites(): FormGroup[] {
        const invitations = <FormArray>this.newUserForm.controls.invitations;
        return <FormGroup[]>invitations.controls.filter(control => !_.isEmpty(control.get('emailAddress').value));
    }

    isInvalid(): boolean {
        const currentUsersSelected = this.currentUserForm.get('invitations').value.filter(invite => invite.selected).length > 0;
        const emptyNewUsers = (<FormArray>this.newUserForm.get('invitations')).length === 1 && _.isEmpty((<FormArray>this.newUserForm.get('invitations')).at(0).value.emailAddress);
        return !(currentUsersSelected || (!emptyNewUsers && this.allNonEmptyNewInvitesValid()));
    }
    
    sendInvites() {
        forkJoin(
            this.userService.sendTopicInvitation(this.topic.id, this.topic.title, this.newUserForm.get('invitations').value.filter(invite => !_.isEmpty(invite.emailAddress))),
            this.userService.sendTopicInvitation(this.topic.id, this.topic.title, this.currentUserForm.get('invitations').value.filter(invite => invite.selected))
        )
        .pipe(
            first()
        )
        .subscribe(() => {
            this.snackBar.open('Invitations sent!.', 'OK', { duration: 3000});
            this.cancel();
        })
        
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
    }
}